
const debtors = {
  debtorsTableTile: "Debtors",
  debtorCreate: "New Debtor",
  debtorsDescription: "Debtors list related to the case",
  validationMessage:
    "Please complete all required fields to continue. {{filedNames}} cannot be left blank.",
  debtorBannerDetails: {
    debtor: "Debtor",
    totalClaims: "Total Claims",
  },
  debtorTabPanelDetails: {
    summary: "Summary",
    claims: "Claims",
  },
  debtorDisablePopup: {
    disableDebtorMessage: "Are you sure to disable this debtor ",
    disableSuccessMessage: "Debtor disabled successfully.",
    cannotDeleteDebtor: "Cannot delete an active debtor ",
  },
  debtorsTabelColumnsDetails: {
    name: "Name",
    totalClaims: "Total Claims {{unitName}}",
    originalClaims: "Original Amount {{unitName}}",
    latestCreditorPosition: "Latest Creditor Position {{unitName}}",
    latestDebtorPositionAmount: "Latest Debtor Position {{unitName}}",
    resolvedAmount: "Resolved  {{unitName}}",
  },
  debtorForm: {
    formTitle: "Debtor Setup",
    formDescription:
      "Please use the full legal name for each Debtor. The description field can be used for other Debtor information such as that date of filing of the Debtor, common abreviations or the jurisdiction of incorporation to assist in clearly identifying the Debtor.",
    formSubTitle: "Debtor Details",
    formSubDescription: "Descriptive text that describes your page or content.",
    formFieldLabels: {
      debtorName: "Debtor Name",
      debtorDescription: "Debtor Description",
    },
  },
  debtorClaimsSection: {
    tableTitle: "Claims",
    tableDescription: "List of all claim under debtor",
    columnsDetails: {
      claimId: "Claim ID",
      creditor: "Creditor",
      assignee: "Assignee",
      unResolvedCreditorAmount: `Latest Creditor Position {{unitName}}`,
      unResolvedDebtorAmount: `Latest Debtor Position {{unitName}}`,
      resolvedAmount: `Resolved Amount {{unitName}}`,
      stage: "Stage",
      status: "Status",
      lastUpdated: "Last Updated",
      claimDetails: "Claim Details",
      originalAmount: `Original Amount {{unitName}}`,
      currentAmount: `Current Amount {{unitName}}`,
    },
    bulkUpload: "Bulk Import",
    addNewClaim: "New Claim",
    export: "Export",
  },
};

export default debtors;
